import ImageCTimur from "../../assets/img/ourTeam/picturePNG/timur_c.png";
import ImageCAnd from "../../assets/img/ourTeam/picturePNG/andrey_c.png";
import ImageCBog from "../../assets/img/ourTeam/picturePNG/bohdan_c.png";
import ImageCNat from "../../assets/img/ourTeam/picturePNG/natalia_c.png";
import ImageCNaz from "../../assets/img/ourTeam/picturePNG/nazar_c.png";
import ImageCSer from "../../assets/img/ourTeam/picturePNG/serhii_c.png";
import ImageCRomP from "../../assets/img/ourTeam/picturePNG/roma_c.png";
import ImageCDm from "../../assets/img/ourTeam/picturePNG/dima_c.png";

export const sliderData = [
  {
    id: "1",
    name: "Roman Stepaniuk",
    description: "Front-End Developer",
    img: ImageCTimur,
  },
  {
    id: "2",
    name: "Andrey Alaverdian",
    description: "Front-End Developer",
    img: ImageCAnd,
  },
  {
    id: "3",
    name: "Bohdan Kovalenko",
    description: "Back-End Developer",
    img: ImageCBog,
  },
  {
    id: "4",
    name: "Natalia Larina",
    description: "Marketer",
    img: ImageCNat,
  },
  {
    id: "5",
    name: "Sakhanda Nazar",
    description: "Front-End Developer",
    img: ImageCNaz,
  },
  {
    id: "6",
    name: "Serhii Lusgar ",
    description: "Web Designer",
    img: ImageCSer,
  },
  {
    id: "7",
    name: "Roman Platonov ",
    description: "Video Editor",
    img: ImageCRomP,
  },
  {
    id: "8",
    name: "Dmytro Shevchenko ",
    description: "Web Designer, Team Leader",
    img: ImageCDm,
  },
];
